import { Component, ChangeDetectionStrategy, inject, input } from '@angular/core';
import { BaseFileAction } from '../base-file-action';
import { IrisFilesService } from '@iris/common/modules/dms/services/files.service';
import { take } from 'rxjs';
import { NgClass } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuItem } from '@angular/material/menu';
import { StrakitButtonComponent } from '@ngx-strakit/cdk/controls';
import { StrakitButtonPrefixDirective } from '@ngx-strakit/cdk';

@Component({
  selector: 'iris-dms-download-file-button',
  imports: [
    NgClass,
    MatTooltipModule,
    MatMenuItem,
    StrakitButtonComponent,
    StrakitButtonPrefixDirective,
  ],
  templateUrl: './dms-download-file-button.component.html',
  styleUrls: ['./dms-download-file-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IrisDmsDownloadFileButtonComponent extends BaseFileAction {
  private readonly filesService = inject(IrisFilesService);

  readonly versionId = input<string>();

  label = 'label.Download';

  downloadFile(): void {
    if (this.versionId()) {
      this.filesService.downloadFileVersion(this.fileId(), this.versionId(), this.fileName()).pipe(
        take(1),
      ).subscribe();
      return;
    }
    this.filesService.downloadFile(this.fileId(), this.fileName()).pipe(
      take(1),
    ).subscribe();
  }
}
